import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import PageWrapper from './../PageWrapper';
import Slider from "react-slick";
import $ from 'jquery';


function Home(props) {
    useEffect(() => {
        var headerheight = $('.main-nav').innerHeight();
        if ($(window).scrollTop() > headerheight){
            $('.nav .main-nav').addClass('full-head');
        }
        else {
            $('.nav .main-nav').removeClass('full-head');
        }
    });
    var settings = {
        dots: true,
        arrows:false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };
    return (
        <PageWrapper title="home">
            <div>
                <header className="header home">
                    <div className="container">
                        <div className="top-dec w-left">
                            <div className="maindiv left-txt">
                                <h1>WE Make good<br />quality health Care</h1>
                                <p>Pellentesque quam ligula, pellentesque at facilisis lacinia, hendrerit vel velit. Suspendisse
                                potenti. Pellentesque ultricies, ipsum ut varius aliquet, sem neque cursus nisl, a gravida
                                nunc orci non justo.</p>
                            </div>
                        </div>
                    </div>
                    <div className="banner_pattern"></div>
                </header>
                <div className="mdc_measure_box mb">
                    <div className="container mdc_measure">
                        <div className="row ">
                            <div className="mdc_lab_box mdcl_l col-12 col-md-6">
                            <div class="mdc_lab_a"><img src={require("../../images/lab_test.png")} /></div>
                            </div>
                            <div className="mdc_lab_box mdcl_r col-12 col-md-6">
                                <h2>Medical Care Full Measure</h2>
                                <p>Morbi sed accumsan quam, id tempor eros. Sed sed justo commodo, sagittis urna ac, ornare sem.
                                Interdum et malesuada fames ac ante ipsum primis in faucibus. Nulla non facilisis arcu, id
                                pharetra risus. Pellentesque congue dui justo, ut dignissim justo ultrices id.</p>
                                <p> Donec non laoreet lorem. Nullam vulputate magna sit amet consequat fermentum. Vestibulum
                                commodo condimentum lectus, eget lobortis est aliquet sit amet. Cras ut quam venenatis,
                                tincidunt elit nec, volutpat velit.</p>
                                <p>Aliquam lobortis tempor dui, in molestie enim auctor at. Nulla tellus tortor, tincidunt ac
                                dolor nec, convallis laoreet diam.</p>
                                <a href="#">Read More<i className="fas fa-long-arrow-alt-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mdc_book_lab_test mb">
                    <div className="container">
                        <div className="mdc-title">
                            <h2>Book Lab Test</h2>
                            <p>Nulla facilisi. Morbi rhoncus posuere ipsum, id feugiat sem lacinia eget<br />mobi ac massa tortor.
					</p>
                        </div>
                        <div className="row">
                            <div className="book_labtst">
                                <div className="lbt_img">
                                    <svg id="line" height="60" viewBox="0 0 64 64" width="60"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="m45.31 15a15.006 15.006 0 1 1 -15 15 15.017 15.017 0 0 1 15-15z" fill="none" />
                                        <path className="svg_c1"
                                            d="m45.31 13a17 17 0 0 0 -15.026 24.952l-16.991 17a1 1 0 0 0 0 1.414l5.649 5.65a1 1 0 0 0 1.415 0l17-16.993a17 17 0 1 0 7.953-32.023zm0 32a15.048 15.048 0 0 1 -7.62-2.07 15.013 15.013 0 1 1 7.62 2.07z" />
                                        <path className="svg_c1"
                                            d="m45.31 17a13 13 0 1 0 13 13 13.015 13.015 0 0 0 -13-13zm-2.477 6.45a6.992 6.992 0 0 0 -4.116 4.191 1 1 0 1 1 -1.883-.673 8.987 8.987 0 0 1 5.291-5.388 1 1 0 0 1 .708 1.87z" />
                                        <g className="svg_c2">
                                            <path
                                                d="m32 31h-3v-3a1 1 0 0 0 -1-1h-4a1 1 0 0 0 -1 1v3h-3a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-3a1 1 0 0 0 -1 1v3h-2v-3a1 1 0 0 0 -1-1h-3v-2h3a1 1 0 0 0 1-1v-3h2v3a1 1 0 0 0 1 1h3z" />
                                            <path
                                                d="m26.823 1.432a1.038 1.038 0 0 0 -1.646 0c-.66.956-16.177 23.524-16.177 32.568a17 17 0 0 0 34 0c0-9.044-15.517-31.612-16.177-32.568zm-.823 47.568a15.017 15.017 0 0 1 -15-15c0-7.3 11.751-25.36 15-30.215 3.25 4.855 15 22.915 15 30.215a15.016 15.016 0 0 1 -15 15z" />
                                        </g>
                                    </svg>
                                </div>
                                <h3>CBC</h3>
                                <p>Vestibulum faucibus egestas </p>
                                <a href="#">Book Now<i className="fas fa-long-arrow-alt-right"></i></a>
                            </div>
                            <div className="book_labtst">
                                <div className="lbt_img">
                                    <svg xmlns="http://www.w3.org/2000/svg" id="line" viewBox="0 0 64 64" width="60"
                                        height="60">
                                        <path className="svg_c1"
                                            d="M41.707,13.293a1,1,0,0,0-1.414,0C39.628,13.958,24,29.772,24,46a17,17,0,0,0,34,0C58,29.772,42.373,13.958,41.707,13.293ZM51,47a1,1,0,0,1-1,1H45v5a1,1,0,0,1-1,1H38a1,1,0,0,1-1-1V48H32a1,1,0,0,1-1-1V41a1,1,0,0,1,1-1h5V35a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v5h5a1,1,0,0,1,1,1Z" />
                                        <path className="svg_c1"
                                            d="M43,41V36H39v5a1,1,0,0,1-1,1H33v4h5a1,1,0,0,1,1,1v5h4V47a1,1,0,0,1,1-1h5V42H44A1,1,0,0,1,43,41Z" />
                                        <path
                                            d="M35,13H32.351l1.005-3.293C34.788,6.255,31.685,1,26,1c-5.65,0-8.81,5.2-7.356,8.707L19.649,13H17a3,3,0,0,0,0,6h1V40.868a3.013,3.013,0,0,0,1.457,2.572L23,45.566V50a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V45.566l3.543-2.126A3.013,3.013,0,0,0,34,40.868V19h1a3,3,0,0,0,0-6ZM20.542,9.074c-.011-.034-.023-.068-.037-.1C19.594,6.848,21.751,3,26,3c4.226,0,6.433,3.787,5.5,5.972-.014.034-.026.068-.037.1L30.26,13H21.74ZM31.514,41.725l-4.029,2.418A1,1,0,0,0,27,45v4H25V45a1,1,0,0,0-.485-.857l-4.03-2.418A1,1,0,0,1,20,40.868v-10.4c.748-.561,2.762-1.641,5.4.337A6.434,6.434,0,0,0,32,31.828v9.04A1,1,0,0,1,31.514,41.725ZM32,29.537c-.748.561-2.762,1.642-5.4-.337A6.392,6.392,0,0,0,20,28.169V19H32ZM35,17H17a1,1,0,0,1,0-2H35a1,1,0,0,1,0,2Z"
                                            className="svg_c2" />
                                        <path d="M23,33a1,1,0,0,0-1,1v5a1,1,0,0,0,2,0V34A1,1,0,0,0,23,33Z" className="svg_c2" />
                                    </svg>
                                </div>
                                <h3>Diabetic test</h3>
                                <p>Nam vehicula, mi et volutpat maximus</p>
                                <a href="#">Book Now<i className="fas fa-long-arrow-alt-right"></i></a>
                            </div>
                            <div className="book_labtst">
                                <div className="lbt_img">
                                    <svg id="line" height="60" viewBox="0 0 64 64" width="60"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path className="svg_c1"
                                            d="m55.55 21.062c-6.191-3.27-12.813-.937-17.561 6.072-4.746-7.009-11.365-9.342-17.56-6.072a14.2 14.2 0 0 0 -7.439 12.667 20.964 20.964 0 0 0 .842 7.305.962.962 0 0 1 .168-.034h11.382l3.724-7.447a1 1 0 0 1 1.864.205l3.345 13.377 2.791-5.582a1 1 0 0 1 .894-.553h11a1 1 0 0 1 0 2h-10.382l-3.718 7.447a1 1 0 0 1 -1.865-.205l-3.349-13.377-2.786 5.582a1 1 0 0 1 -.9.553h-11.451c3.473 8.3 12.4 16.283 23.128 19.946a.993.993 0 0 0 .646 0c26.254-8.962 24.623-29.116 24.667-29.217a14.2 14.2 0 0 0 -7.44-12.667z" />
                                        <g className="svg_c2">
                                            <path
                                                d="m48 5h-44a3 3 0 0 0 -3 3v36a3 3 0 0 0 3 3h44a3 3 0 0 0 3-3v-36a3 3 0 0 0 -3-3zm1 39a1 1 0 0 1 -1 1h-44a1 1 0 0 1 -1-1v-36a1 1 0 0 1 1-1h44a1 1 0 0 1 1 1z"/>
                                            <path
                                                d="m44 9h-36a3 3 0 0 0 -3 3v20a3 3 0 0 0 3 3h36a3 3 0 0 0 3-3v-20a3 3 0 0 0 -3-3zm1 23a1 1 0 0 1 -1 1h-36a1 1 0 0 1 -1-1v-20a1 1 0 0 1 1-1h36a1 1 0 0 1 1 1z" />
                                            <path
                                                d="m42 21h-10a1 1 0 0 0 -.894.553l-2.106 4.211-5.1-10.211a1.041 1.041 0 0 0 -1.789 0l-2.729 5.447h-9.382a1 1 0 0 0 0 2h10a1 1 0 0 0 .895-.553l2.105-4.211 5.106 10.211a1 1 0 0 0 1.789 0l2.723-5.447h9.382a1 1 0 0 0 0-2z" />
                                            <path d="m42 37a3 3 0 1 0 3 3 3 3 0 0 0 -3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1 -1 1z" />
                                            <path d="m13 39h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2z" />
                                            <path d="m22 39h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2z" />
                                        </g>
                                    </svg>
                                </div>
                                <h3>ECG</h3>
                                <p>Morbi vel mauris non libero</p>
                                <a href="#">Book Now<i className="fas fa-long-arrow-alt-right"></i></a>
                            </div>
                            <div className="book_labtst">
                                <div className="lbt_img">
                                    <svg id="line" height="60" viewBox="0 0 64 64" width="60"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g className="svg_c1">
                                            <path
                                                d="m35.99 26.142c-.6 4.183-.058 7.335 1.518 8.875 2.8 2.74 3.766-1.241 11.248 3.406 4.262 2.644 8.289 5.135 14.208-1.753a24.984 24.984 0 0 0 -37.111-20.51c2.531.592 11.117 3.121 10.137 9.982z" />
                                            <path
                                                d="m47.7 40.122c-7-4.345-7.861-.028-11.592-3.675-2.073-2.026-2.8-5.687-2.1-10.589.852-5.962-9.089-7.856-9.19-7.875a.992.992 0 0 1 -.774-.717 25 25 0 0 0 -11.018 19.724c1.622-.185 14.9-1.372 17.932 8.723 4.587 15.3 20.112.988 26.385 8.1a24.877 24.877 0 0 0 5.6-14.214c-5.179 4.95-9.329 4.192-15.243.523z" />
                                            <path
                                                d="m29.042 46.287c-2.715-9.05-15.768-7.316-15.9-7.3a.892.892 0 0 1 -.116-.006 24.978 24.978 0 0 0 42.954 16.363c-4.721-6.096-21.68 8.469-26.938-9.057z" />
                                        </g>
                                        <path
                                            d="m32 26a6 6 0 1 0 6 6 6.006 6.006 0 0 0 -6-6zm0 10a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
                                            className="svg_c2" />
                                        <path d="m21 14.477a4 4 0 1 0 4 4 4 4 0 0 0 -4-4zm0 6a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z"
                                            className="svg_c2" />
                                        <path
                                            d="m48 25h-3.051a18.892 18.892 0 0 0 -4.849-11.688l2.605-2.6a1 1 0 0 0 -1.414-1.414l-2.6 2.605a18.892 18.892 0 0 0 -11.691-4.852v-3.051a1 1 0 0 0 -2 0v3.051a18.892 18.892 0 0 0 -11.688 4.849l-2.012-2.017a1 1 0 0 0 -1.417 1.417l2.017 2.012a18.892 18.892 0 0 0 -4.849 11.688h-3.051a1 1 0 0 0 0 2h3.051a18.892 18.892 0 0 0 4.849 11.688l-2.605 2.6a1 1 0 0 0 1.414 1.414l2.6-2.605a18.892 18.892 0 0 0 11.691 4.852v3.051a1 1 0 0 0 2 0v-3.051a18.892 18.892 0 0 0 11.688-4.849l2.6 2.605a1 1 0 0 0 1.414-1.414l-2.605-2.6a18.892 18.892 0 0 0 4.852-11.691h3.051a1 1 0 0 0 0-2zm-22 18a17 17 0 1 1 17-17 17.019 17.019 0 0 1 -17 17z"
                                            className="svg_c2" />
                                    </svg>
                                </div>
                                <h3>Covid-19 Test</h3>
                                <p>Duis vulputate interdum erat</p>
                                <a href="#">Book Now<i className="fas fa-long-arrow-alt-right"></i></a>
                            </div>
                        </div>
                        <div className="lbt_btn"><a href="#" className="mbtn">view all</a></div>
                    </div>
                </div>
                <div className="mdc_care mb">
                    <div className="mdc-title">
                        <h2>Medicenter Cares for You</h2>
                        <p>We offer services for any patient that needs to get well</p>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="care_item col-12 col-sm-4">
                                <h3>Our Services</h3>
                                <a href="#"><img src={require("../../images/care_1.png")} /></a>
                                <p>Aecenas in sollicitudin ipsum. Aenean cursus tempus gravida. Vivamus nec laoreet ligula, ut
                                posuere leo. Maecenas aliquam urna vitae nisi commodo, et varius nulla molestie. Integer
                                varius mollis enim. Nulla porttitor tincidunt efficitur. Maecenas rhoncus consequat elit,
                                eget dictum velit maximus id. Mauris luctus convallis felis, et scelerisque lacus mattis et.
						</p>
                            </div>
                            <div className="care_item col-12 col-sm-4">
                                <h3>Patient Care</h3>
                                <a href="#"><img src={require("../../images/care_1.png")} /></a>
                                <p>Maecenas ut est pretium, commodo felis in, dapibus lacus. Vestibulum porttitor vulputate
                                justo, eget congue sapien ornare vulputate. Nullam mattis felis eget nunc mattis, sit amet
                                condimentum purus dignissim. Nam eget quam sed eros iaculis mattis. Aenean efficitur vitae.
						</p>
                            </div>
                            <div className="care_item col-12 col-sm-4">
                                <h3>Patient Reviews</h3>
                                <a href="#"><img src={require("../../images/care_1.png")} /></a>
                                <p>Quisque turpis nulla, viverra non molestie quis, scelerisque at justo. Suspendisse potenti.
                                Suspendisse potenti. Aenean sed tortor venenatis, venenatis nibh eget, facilisis mauris. Ut
                                non scelerisque magna. Integer pharetra scelerisque tortor eu volutpat. Suspendisse ac risus
							et dolor condimentum malesuada.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="client_testimonial mb">
                    <div className="container">
                        <div className="mdc-title">
                            <h2>Patient Testimonials</h2>
                        </div>
                        <div className="row">
                            <div className="col-12 f-left clientreviewdiv_box">
                                <div className="clienttestimonial_slider">
                                    <Slider {...settings}>
                                    <div className="clientreviewdiv clientrev1">
                                        <img className="pateintimg" src={require("../../images/pateint_1.png")} />
                                        <div className="innerclient_box animation">
                                            <div className="reviews_name">
                                                <h3>Lacinia aliquam sapien</h3>
                                                <span>- Joshua Reid</span>
                                            </div>
                                            <p>"Curabitur aliquam justo turpis, vitae tempus dui dignissim et. Ut gravida justo
                                            auctor, convallis ex et, posuere neque. Morbi urna lorem, semper vitae ligula
										at, sagittis dapibus erat. Nam vulputate tellus sed congue sagittis."</p>
                                            <div className="review_i">
                                                <span><i className="fas fa-star"></i></span>
                                                <span><i className="fas fa-star"></i></span>
                                                <span><i className="fas fa-star"></i></span>
                                                <span><i className="fas fa-star"></i></span>
                                                <span><i className="far fa-star"></i></span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="clientreviewdiv clientrev2">
                                        <img className="pateintimg" src={require("../../images/pateint_1.png")} />
                                        <div className="innerclient_box animation">
                                            <div className="reviews_name">
                                                <h3>Lacinia aliquam sapien</h3>
                                                <span>- Joshua Reid</span>
                                            </div>
                                            <p>"Curabitur aliquam justo turpis, vitae tempus dui dignissim et. Ut gravida justo
                                            auctor, convallis ex et, posuere neque. Morbi urna lorem, semper vitae ligula
										at, sagittis dapibus erat. Nam vulputate tellus sed congue sagittis."</p>
                                            <div className="review_i">
                                                <span><i className="fas fa-star"></i></span>
                                                <span><i className="fas fa-star"></i></span>
                                                <span><i className="fas fa-star"></i></span>
                                                <span><i className="fas fa-star"></i></span>
                                                <span><i className="fas fa-star-half-alt"></i></span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="clientreviewdiv clientrev3">
                                        <img className="pateintimg" src={require("../../images/pateint_1.png")} />
                                        <div className="innerclient_box animation">
                                            <div className="reviews_name">
                                                <h3>Lacinia aliquam sapien</h3>
                                                <span>- Joshua Reid</span>
                                            </div>
                                            <p>"Curabitur aliquam justo turpis, vitae tempus dui dignissim et. Ut gravida justo
                                            auctor, convallis ex et, posuere neque. Morbi urna lorem, semper vitae ligula
										at, sagittis dapibus erat. Nam vulputate tellus sed congue sagittis."</p>
                                            <div className="review_i">
                                                <span><i className="fas fa-star"></i></span>
                                                <span><i className="fas fa-star"></i></span>
                                                <span><i className="fas fa-star"></i></span>
                                                <span><i className="fas fa-star-half-alt"></i></span>
                                                <span><i className="far fa-star"></i></span>
                                            </div>
                                        </div>
                                    </div>

                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mdc_team mb">
                    <div className="mdc-title">
                        <h2>Our Professionals</h2>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="team_inner">
                                <div class="team_inner_a">
                                    <img src={require("../../images/doctor_1.png")} /></div>
                                    <h3>Dr Suspendisse cursus</h3>
                                    <span>Surgeon</span>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="team_inner">
                                <div class="team_inner_a"><img src={require("../../images/doctor_2.png")} /></div>
                                    <h3>Dr Nunc eleifend</h3>
                                    <span>Nurse</span>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="team_inner">
                                <div class="team_inner_a"><img src={require("../../images/doctor_3.png")} /></div>
                                    <h3>Dr Morbi convallis</h3>
                                    <span>Surgeon</span>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3">
                                <div className="team_inner">
                                <div class="team_inner_a"><img src={require("../../images/doctor_1.png")} /></div>
                                    <h3>Dr Duis nec</h3>
                                    <span>Assistance</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="free_consultancy w-left">
                    <div className="container">
                        <div className="row">
                            <div className="free_consult_inner">
                                <div className="fc_left col-12 col-lg-3">
                                    <h3>Get Free Consultany</h3>
                                    <p><span>Call to</span><a href=":tel">+(9)677-788-8788</a></p>
                                </div>
                                <div className="fc_right col-12 col-lg-9">
                                    <form action="" method="">
                                        <input type="email" name="your email" placeholder="Your Email" />
                                        <input type="text" name="your name" placeholder="Your Name" />
                                        <input type="button" value="Get it Now" />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageWrapper>
    )
}

//export default Home;
export default withRouter(Home);